import Link from '@jetbrains/ring-ui-built/components/link/link'
import type {ReactNode} from 'react'

import styles from './Integrations.module.css'

export enum IntegrationType {
  NPM = 'NpmRegistry',
  DOCKER = 'Docker',
  UNITY = 'Unity',
}

type IntegrationElements = {
  displayName: string
  description: (parameters: Record<string, string | null>) => string
  note?: (parameters: Record<string, string | null>) => ReactNode
  defaultParameters: Record<string, string>
}

export const maxIntegrationsToShow = 5

export const integrations: Record<string, IntegrationElements> = {
  [IntegrationType.NPM]: {
    displayName: 'NPM',
    description: parameters =>
      `Registry URL: ${parameters.npmRegistryHost || 'Registry URL not set'}`,
    defaultParameters: {
      npmRegistryHost: 'https://registry.npmjs.org',
      'secure:npmRegistryToken': '',
      npmRegistryScope: '',
    },
    note: parameters => {
      const url = parameters.npmRegistryHost
      const scope = parameters.npmRegistryScope
      return (
        <>
          {url && (
            <Link target="_blank" className={styles.link} href={url} rel="noreferrer">
              {url}
            </Link>
          )}
          {scope && ` as ${scope}`}
        </>
      )
    },
  },
  [IntegrationType.DOCKER]: {
    displayName: 'Docker',
    description: parameters => `Username: ${parameters.userName || 'Username not set'}`,
    defaultParameters: {repositoryUrl: 'https://docker.io', userName: '', 'secure:userPass': ''},
    note: parameters => {
      const url = parameters.repositoryUrl
      return (
        url && (
          <Link target="_blank" className={styles.link} href={url} rel="noreferrer">
            {url}
          </Link>
        )
      )
    },
  },
  [IntegrationType.UNITY]: {
    displayName: 'Unity',
    description: parameters => `Username: ${parameters.username || 'Username not set'}`,
    defaultParameters: {
      unityLicenseType: 'professionalLicense',
      username: '',
      'secure:password': '',
      'secure:serialNumber': '',
    },
    note: parameters => parameters.username,
  },
}
